import { frontendURL } from '../../../../helper/URLHelper';

import SettingsWrapper from '../SettingsWrapper.vue';
import Index from './Index.vue';
import Builder from './Builder.vue';
import RunsPage from './RunsPage.vue';
import ErrorLog from './ErrorLog.vue';
import TemplateGallery from './TemplateGallery.vue';

// Teletel Flows pages front the /teletel backend. Keep the client-side route
// guard aligned with the server-side PermissionGuard: administrators and
// custom roles with flow_manage can manage flows, while template-only roles
// can open only the gallery.
const flowManageMeta = {
  permissions: ['administrator', 'flow_manage'],
};
// The builder is a canvas, not a form: it gets the full viewport instead of the
// centred, bounded card the other settings pages use.
const builderMeta = {
  ...flowManageMeta,
  fullWidth: true,
};
const templateUseMeta = {
  permissions: ['administrator', 'flow_template_use'],
};

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/teletel-flows'),
      component: SettingsWrapper,
      props: {},
      children: [
        {
          path: '',
          name: 'teletel_flows_wrapper',
          meta: flowManageMeta,
          redirect: to => ({ name: 'teletel_flows_list', params: to.params }),
        },
        {
          path: 'list',
          name: 'teletel_flows_list',
          meta: flowManageMeta,
          component: Index,
        },
        {
          path: 'templates',
          name: 'teletel_flows_templates',
          meta: templateUseMeta,
          component: TemplateGallery,
        },
        {
          path: 'new',
          name: 'teletel_flows_new',
          meta: builderMeta,
          component: Builder,
        },
        {
          path: ':flowId/edit',
          name: 'teletel_flows_edit',
          meta: builderMeta,
          component: Builder,
        },
        {
          path: 'runs',
          name: 'teletel_flows_runs',
          meta: flowManageMeta,
          component: RunsPage,
        },
        {
          path: 'errors',
          name: 'teletel_flows_errors',
          meta: flowManageMeta,
          component: ErrorLog,
        },
      ],
    },
  ],
};
